import { render } from "./BattleRecord.vue?vue&type=template&id=f1c57276&scoped=true"
import script from "./BattleRecord.vue?vue&type=script&lang=js"
export * from "./BattleRecord.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=f1c57276&scoped=true&lang=css&external"
import "./BattleRecord.vue?vue&type=style&index=1&id=f1c57276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c57276"]])

export default __exports__